import { Dictionary, InjectMember } from '.';
var Inject = (function () {
    function Inject(dictionary) {
        if (dictionary === void 0) { dictionary = null; }
        this.dictionary = dictionary || new Dictionary();
    }
    Inject.prototype.register = function (name, constructor, resolve) {
        if (this.dictionary.containsKey(name)) {
            this.dictionary.remove(name);
        }
        this.dictionary.add(name, new InjectMember(constructor, resolve));
    };
    Inject.prototype.resolve = function (name) {
        if (this.dictionary.containsKey(name)) {
            var item = this.dictionary.value(name);
            return item.getObject();
        }
        return null;
    };
    Object.defineProperty(Inject, "Instance", {
        get: function () {
            if (this.myInstance === undefined) {
                this.myInstance = new Inject();
            }
            return this.myInstance;
        },
        enumerable: false,
        configurable: true
    });
    return Inject;
}());
export { Inject };
